import React from 'react';
import { track } from '@amplitude/analytics-browser';
import { Box, Button, Card, Icon, Text, Title } from '@nimbus-ds/components';
import { DiscountCircleIcon, LockIcon, MoneyIcon } from '@nimbus-ds/icons';
import { goTo } from '@tiendanube/nexo';
import nexo from 'App/nexoClient';
import { ADMIN_ROUTES } from 'App/Routes/constants';
import { IconBox } from 'commons/components';
import { useIsMobile } from 'commons/hooks';
import { useTranslationWithPrefix } from 'commons/utils';
import EmptyStateSecondSectionSkeleton from './EmptyStateSecondSectionSkeleton';

function EmptyStateSecondSection(): JSX.Element {
  const isMobile = useIsMobile();
  const { t } = useTranslationWithPrefix('emptyState.secondSection');

  const trackCostsAndRedirectToPayment = async () => {
    await track('pagonube_costs_empty_click').promise;
    goTo(nexo, ADMIN_ROUTES.PAYMENT_METHODS);
  };

  const SectionCard = ({
    icon,
    title,
    description,
  }: {
    icon: React.ReactNode;
    title: string;
    description: string;
  }) => (
    <Card padding="base">
      <Box display="flex" flexDirection="column" gap="4">
        <IconBox
          backgroundColor="primary-surface"
          borderRadius="full"
          height="40px"
          width="40px"
        >
          <Icon source={icon} color="primary-interactive" />
        </IconBox>
        <Title as="h4">{title}</Title>
        <Text color="neutral-textHigh">{description}</Text>
      </Box>
    </Card>
  );

  return (
    <Box display="flex" flexDirection="column" gap="8">
      <Title as={isMobile ? 'h3' : 'h2'}>{t('title')}</Title>
      <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} gap="4">
        <Box flex="1">
          <SectionCard
            icon={<DiscountCircleIcon size="medium" />}
            title={t('competitiveRates.title')}
            description={t('competitiveRates.description')}
          />
        </Box>
        <Box flex="1">
          <SectionCard
            icon={<LockIcon size="medium" />}
            title={t('antifraud.title')}
            description={t('antifraud.description')}
          />
        </Box>
        <Box flex="1">
          <SectionCard
            icon={<MoneyIcon size="medium" />}
            title={t('secureTransfers.title')}
            description={t('secureTransfers.description')}
          />
        </Box>
      </Box>
      <Box display="flex">
        <Button onClick={trackCostsAndRedirectToPayment}>
          <Text color="neutral-textHigh" fontSize="base" fontWeight="medium">
            {t('knowCosts')}
          </Text>
        </Button>
      </Box>
    </Box>
  );
}

EmptyStateSecondSection.Skeleton = EmptyStateSecondSectionSkeleton;
export default EmptyStateSecondSection;
